import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';

export interface ReplyProps extends ContextProps {
    reply: any;
}

export enum ResponseState {
    Start = 'Start',
    PendingManual = 'PendingManual',
    PendingApproval = 'PendingApproval',
    PendingModeration = 'PendingModeration',
    Posted = 'Posted',
    Rejected = 'Rejected',
    PendingPublish = 'PendingPublish',
    Published = 'Published',
    Failed = 'Failed',
    Live = 'Live',
}

export enum ResponseFailedReason {
    ClientRequest = 'ClientRequest',
    DidNotPostForOtherReason = 'DidNotPostForOtherReason',
    CredentialsMissing = 'CredentialsMissing',
    CredentialsInvalid = 'CredentialsInvalid',
    ReviewDeleted = 'ReviewDeleted',
    UnableToPostForOtherReason = 'UnableToPostForOtherReason',
    Other = 'Other',
}

export enum UserType {
    User = 'User',
    Customer = 'Customer',
    Business = 'Business',
}
